export const selectedOrdersContainerStyle = {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0E0E0',
    borderRadius: '0.5rem',
    padding: '1rem',
    marginBottom: '1.5rem',
};

export const tableHeadersContainerStyle = {
    display: 'flex',
    alignItems: 'flex-end',
    columnGap: '1.5rem',
    marginBottom: '1rem',
};

export const actionButtonStyle = (buttonOpacity: number, buttonTransform: string, disabled: boolean) => ({
    cursor: disabled ? 'default' : 'pointer',
    display: 'flex',
    alignItems: 'center',
    opacity: buttonOpacity,
    transform: buttonTransform,
    transition: 'all 0.2s ease',
    flexShrink: 0,
    alignSelf: 'center',
});
